import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { LanguageLink } from './language-link.model';
import { FooterService } from './footer.service';
import { UserSession } from '@mem-shared/user-session';
import { UtilService } from '@mem-shared/util.service';
import { UpdateLobService } from '@mem-shared/update-lob.service';
import { VersionConst } from 'app/shared/version';
import { filter } from 'rxjs/operators';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { ActivityFeed } from './activity-feed.model';
import { NativeIntegrationService } from '@mem-shared/native-integration.service';
import { EventService } from '@mem-shared/event.service';
import { Subscription } from 'rxjs/Subscription';

const SHOW_LINKS_DEFAULT = {
  contactUs: false,
  faqs: false,
  sitemap: false,
  rightsAndResponsibilities: false,
  showAccountActivity: false
};

@Component({
  selector: 'mem-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  languageLinks: LanguageLink[];
  showLinks = SHOW_LINKS_DEFAULT;
  guid: string;
  version: string;
  appVersion: string;
  currentUrl: string;
  showLoginReloader: boolean;
  showAccountActivity: boolean;
  isAccountActivityLoading: boolean;
  accountActivityFailed: boolean;
  accounActivityDetail: ActivityFeed[];
  loader: boolean;
  recallVersionJson$: Subscription;
  environment: string;
  deviceType: string;
  nativeOs; 
  lob: string;

  @Input()
  set isAuthenticated(isAuthenticated) {
    if (isAuthenticated) {
      this.showLinks = this.setFeatureFlags();
    } else {
      this.showLinks = SHOW_LINKS_DEFAULT;
    }
  }

  constructor(
    private footerService: FooterService,
    private activatedroute: ActivatedRoute,
    public userSession: UserSession,
    private eventService: EventService,
    private router: Router,
    public utilService: UtilService,
    public nativeService: NativeIntegrationService,
    private updateLobService: UpdateLobService
    // public eventService: EventService
  ) { }

  @ViewChild('accountActivityModal') public accountActivityModal: ModalDirective;
  show() {
    this.accountActivityModal.show();
  }
  hide() {
    this.accountActivityModal.hide();
  }

  showActivityFeed() {
    window.scrollTo(0, 0);
    this.accountActivityModal.show();
    // code change for 3/8
    let userId = this.userSession.getCookie('theUserID') || "ebizUser";
    this.loader = true;
    this.footerService.getActivityFeed(userId).subscribe(params => {
      this.loader = false;
      if (params && !params.error) {
        this.accounActivityDetail = params.activityFeedList;
      }
    }, (error: any) => {
      this.loader = false;
      this.accountActivityFailed = true;
    });
  }

  ngOnInit() {
    this.nativeOs = this.utilService.getNativeOS();
    this.deviceType = this.utilService.getDeviceType();
    this.version = VersionConst.myAccount.version;
    console.log("checkTargetLink in footer");
    this.nativeService.invokeNativeService(this.nativeOs, 'checkTargetLink', null);

    if (this.nativeOs === 'Android') {
      this.appVersion = VersionConst.memberMobile.android.latestVersionName;
      this.eventService.subscribe('Reload_Version.json', () => {
        this.environment = this.nativeService.getTargetURL();
      });
    }
    if (this.nativeOs === 'iOS') {
      this.appVersion = VersionConst.memberMobile.ios.bundleVersion;
      this.environment = this.nativeService.getTargetURL();
    }

    this.version = VersionConst.myAccount.version;

    if (this.nativeOs === 'Android') {
      this.appVersion = VersionConst.memberMobile.android.latestVersionName;
      this.eventService.subscribe('Reload_Version.json', () => {
        this.environment = this.nativeService.getTargetURL();
      });
    }
    if (this.nativeOs === 'iOS') {
      this.appVersion = VersionConst.memberMobile.ios.bundleVersion;
      this.environment = this.nativeService.getTargetURL();
    }

    this.eventService.subscribe('GUID', guid => {
      this.guid = guid;
    });

    /*
    * This is called whenever an event is triggred and there is a change in URL
    * it will help us to hide the two'dots' in footer when not in login page
    */
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd))
      .subscribe((event: any) => {
        if (event.url) {
          if (event.url === '/login') {
            this.showLoginReloader = true;
          } else {
            this.showLoginReloader = false;
          }
        }
      });
  
    //To get the lob value from storage - setting to MEMBER as default if empty
    // if (this.userSession.getLocalStorageItem('lob') == 'CHPDC' || this.userSession.getLocalStorageItem('lob') == 'CHPMD' ||
    //   this.userSession.getLocalStorageItem('lob') == 'DSNP' || this.userSession.getLocalStorageItem('lob') == 'VAEX' || this.userSession.getLocalStorageItem('lob') == 'EGWP'||
    //   this.userSession.getLocalStorageItem('lob') == 'MAPD' || this.userSession.getLocalStorageItem('lob') == 'MHBE') {
    //   this.lob = this.userSession.getLocalStorageItem('lob')
    // } else {
    //   this.lob = 'MEMBER';
    // }
    // To resolve cache issue for okta login widget - setting lob from service
    this.updateLobService.lobSrc.subscribe(response => {this.lob = response; });

    // Calling the language service for only member type registrant
    if ( this.lob == 'MEMBER')
      {
        this.bindService();
      } 
 }

  bindService() {
    setTimeout(() => {
      this.footerService.getFooterLanguageLinks().subscribe(links => {
        this.languageLinks = links;
      });
    }, 1000);
  }

  private setFeatureFlags() {
    return {
      contactUs: this.userSession.getMemberFeatureFlags().showContactUs,
      faqs: this.userSession.getMemberFeatureFlags().showMemberHelpFAQ,
      sitemap: true,
      rightsAndResponsibilities: true,
      showAccountActivity: true
    };
  }

  /**
   * Function for reloading the route (only Login) by useing routeReuseStrategy
   * Making router.navigated to false. Used for reloading the route when the outage
   * is displayed per Pratap & Tom...
   */
  reloadLoginPage() {
    this.router.routeReuseStrategy.shouldReuseRoute = function () { return false; };
    this.router.navigateByUrl(this.router.url)
      .then(() => {
        this.router.navigated = false;
        this.userSession.setCookie('CF-IMPS', '1');
        this.router.navigate([this.router.url]);
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/core/footer/footer.component.ts